import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'

// Performance monitoring in development
if (import.meta.env.DEV) {
  // Enable React DevTools profiler
  if (typeof window !== 'undefined' && (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    const hook = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (hook) {
      hook.onCommitFiberRoot = (id: any, root: any, priorityLevel: any) => {
        // Optional: Add performance logging here
      };
    }
  }
}

// Error boundary for the entire application
const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Hot module replacement for development
if (import.meta.hot) {
  import.meta.hot.accept()
}